import React from "react";
import { NavLink } from "react-router-dom";

function FinanceOrdersActions() {
  return (
    <nav className="uk-position-relative" aria-label="Breadcrumb">
      <ul className="uk-breadcrumb">
        <li>
          <NavLink to="/Cars">السيارات</NavLink>
        </li>
        <li>
          <span aria-current="page">طلبات تمويل السيارات</span>
        </li>
      </ul>
    </nav>
  );
}

export default FinanceOrdersActions;
